import { useContext, useEffect } from 'react';
import useTitle from '../../hooks/UseTitle';
import { CategoriesContext } from '../../contexts/CategoriesContext';

function Home() {
  useTitle('BUILD-SELF');

  const { requestCategoryList } = useContext(CategoriesContext);

  useEffect(() => {
    requestCategoryList();
  }, [requestCategoryList]);

  return (
    <>
    </>
  );
}

export default Home;
